import { QRCodeSVG } from "qrcode.react";
import Spinner from "../spinner";

type Props = {
	qrCode?: string | null;
};

const QrCode = ({ qrCode }: Props) => (
	<div className="my-4 flex items-center justify-center">
		{qrCode ? (
			<QRCodeSVG value={qrCode} size={180} level="M" />
		) : (
			<div className="flex h-[180px] items-center">
				<Spinner size={40} />
			</div>
		)}
	</div>
);

export default QrCode;
